import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { delay, Observable, of, tap } from 'rxjs';
import { IProveedoresEelement } from '../../../app/interfaces/proveedores';
import { environment } from '../../../environments/environment';

let ELEMENT_DATA: IProveedoresEelement[] = [];

@Injectable({
  providedIn: 'root'
})
export class ProveedoresService {

  constructor(private http:HttpClient ) {

  }

  getEmpresas(id){
    return this.http.get<any>(`${environment.base}${environment.catalogos_port}catalogoEmpresaSolicitante/${id}`) ;   
  }

  getTiposMoneda(){
    return this.http.get<any>(`${environment.base}${environment.catalogos_port}tipo-moneda`) ;   
  }

  getTiposCompra(){
    return this.http.get<any>(`${environment.base}${environment.catalogos_port}tipo-compra`) ;   
  }

  getFormaPago(id){
    return this.http.get<any>(`${environment.base}${environment.catalogos_port}forma-pago/${id}`) ;   
  }

  getListaProveedores(){
    return this.http.get<any>(`${environment.base}${environment.catalogos_port}Proveedor-detalle`) ;   
  }

  getBancos(){
    return this.http.get<any>(`${environment.base}${environment.catalogos_port}bancos`) ;   
  }

  getValidarBanco(body){
    return this.http.post<any>(`${environment.base}${environment.catalogos_port}validarbanco`, body) ;   
  }

  getDatosProveedor(razon, nombre){
    return this.http.get<any>(`${environment.base}${environment.catalogos_port}proveedor-detalle/${razon}/${nombre}`) ;   
  }

  getProveedorPorClave(clave,valor?){
    
    return this.http.get<any>(`${environment.base}${environment.catalogos_port}consulta-proveedor/${clave}/${valor}`) ; 
  }

  getRegimenFiscal(){
    return this.http.get<any>(`${environment.base}${environment.catalogos_port}regimen-fiscal`) ;   
  }

  getCondicionesPago(){
    return this.http.get<any>(`${environment.base}${environment.catalogos_port}condiciones-pago`) ;   
  }

  getPaises() {
    return this.http.get<any>(`${environment.base}${environment.catalogos_port}getPaises`);
  }

  getEstadosPorPais(id) {
    return this.http.get<any>(`${environment.base}${environment.catalogos_port}getEstados/${id}`);
  }

  getTipoPersona(){
    return this.http.get<any>(`${environment.base}${environment.catalogos_port}tipo-persona`) ;   
  }

  getProveedoresPorAprobar(body){
    return this.http.post<any>(`${environment.base}${environment.catalogos_port}por-aprobar`, body) ;   
  }

  getProveedorAltaBanco(body){
    return this.http.post<any>(`${environment.base}${environment.catalogos_port}selectProveedorAltasenBanco`, body) ;   
  }

  postGuardarProveedor(body){
    return this.http.post<any>(`${environment.base}${environment.catalogos_port}proveedor-registro`, body) ;   
  }

  putGuardarProveedor(body){
    return this.http.put<any>(`${environment.base}${environment.catalogos_port}actualizar-proveedor`, body) ;   
  }

  enviarPdf(data) {
    return this.http.post<any>(`${environment.base}${environment.catalogos_port}carga-documentos`, data);
  }

  solicitaCSF(data) {
    return this.http.post<any>(`${environment.base}${environment.catalogos_port}seleccionCSF`, data);
  }

  getProveedoresEstatus() {
    return this.http.get<any>(`${environment.base}${environment.catalogos_port}proveedor-estatus`);
  }

  getEstatusProveedores(id) {
    return this.http.get<any>(`${environment.base}${environment.catalogos_port}estatusproveedor/${id}`);
  }

  getProveedoresPorFiltro(body) {
    return this.http.post<any>(`${environment.base}${environment.catalogos_port}buscar-filtros`, body);
  }

  updateStatus(body){
    return this.http.put<any>(`${environment.base}${environment.catalogos_port}statusupdate`, body);
  }

  validarRFC(body) {
    return this.http.post<any>(`${environment.base}${environment.catalogos_port}validarfc`, body);
  }

  validarIdRFC(body) {
    return this.http.post<any>(`${environment.base}${environment.sat_port}validarfc_sat`, body);
  }

  descargarMovimientos(body) {
    return this.http.post<any>(`${environment.base}${environment.catalogos_port}reportemodificaciones`, body);
  }

  descargarReporte(body) {
    return this.http.post<any>(`${environment.base}${environment.catalogos_port}listaproveedores`, body);
  }

  altaBancoProveedor(body){
    return this.http.put<any>(`${environment.base}${environment.catalogos_port}registraAltaBanco`, body) ;   
  }

  getLength(filter: string) {
      return of(this.getElement('').length)
        .pipe(delay(500), tap(_ => {  }));
    }
  
    getData(page: number, pageSize: number, sortField: string, sortDirection: string) {
      const factor = sortDirection == 'desc' ? -1 : sortDirection == 'asc' ? 1 : 0
      return factor ? of(this.getElement('')
        // .sort((a: any, b: any) => a[sortField] > b[sortField] ? -factor : factor)
        .slice((page - 1) * pageSize, page * pageSize)).pipe(
          delay(500), tap(_ => { })) :
        of(this.getElement('')
          .slice((page - 1) * pageSize, page * pageSize)).pipe(
            delay(500), tap(_ => { }))
    }
  
    getElement(filter: string) {
      return !filter ? [...ELEMENT_DATA] : ELEMENT_DATA.filter(x => x.folio.indexOf(filter) >= 0)
    }
  
    setData(body: any) {
      ELEMENT_DATA = []
      console.log(body)
      ELEMENT_DATA = body
    }
  
    getInfo(){
      console.log(this.data)
      return this.data
    }
  
    data = []

    getTimelineProveedor(idProveedor: number) {
      return this.http.get<any>(`${environment.base}${environment.catalogos_port}timeLineEstatus/${idProveedor}`);
    }

  cargaOpinionSatDoc(data) {
    return this.http.post<any>(`${environment.base}${environment.catalogos_port}carga-OpinionSat`, data);
  }
    
  
}